/**
 * What the Goal step says about the chosen Goal and the recommended one: one module, so the
 * product copy is one file to change.
 */

/**
 * Inside the chosen Goal, above the options, once the study's Materials changed under it. True
 * whether or not options for the new Materials are on screen yet.
 */
export const GOAL_INPUTS_CHANGED_NOTICE =
  'Your materials changed since you chose this goal. It stays your goal unless you pick one of the goals drafted for the new materials.';

/** The name a screen reader gives the `?` beside Recommended, whose tooltip holds the reason. */
export const GOAL_RECOMMENDED_WHY_LABEL = 'Why Sigora recommends this goal';
